<template>
  <div class="laborales">
    <!-- <pre>{{ldata}}</pre> -->
    <div class="laborales__tabs">
      <div
        class="laborales__tab"
        @click="currentView = 'Principal'"
        :class="{ 'tab-selected': currentView == 'Principal' }"
      >
        Principal
      </div>
      <div
        class="laborales__tab"
        @click="currentView = 'Direccion'"
        :class="{ 'tab-selected': currentView == 'Direccion' }"
      >
        Dirección
      </div>
      <div
        class="laborales__tab"
        @click="currentView = 'Laboral'"
        :class="{ 'tab-selected': currentView == 'Laboral' }"
      >
        Laboral
      </div>
    </div>

    <div class="laborales__views">
      <div class="laborales__principal" v-show="currentView == 'Principal'">
        <!-- tipo de documento -->
        <md-field>
          <label for="documentType">Tipo de Documento</label>
          <md-select
            v-model="ldata.documentType"
            name="documento"
            id="documento"
            placeholder="Tipo de Documento"
            required
          >
            <md-option value="01">DNI</md-option>
            <md-option value="04">CARNÉ DE EXTRANJERÍA</md-option>
            <md-option value="07">PASAPORTE</md-option>
            <md-option value="23">PTP</md-option>
          </md-select>
        </md-field>

        <!-- numero de documento -->
        <md-field :class="getValidationClass($v.ldata.documentNumber)">
          <label>Número Documento</label>
          <md-input
            name="nroDocumento"
            id="nroDocumento"
            v-model="ldata.documentNumber"
            required
          ></md-input>
          <span class="md-error" v-if="!$v.ldata.documentNumber.required"
            >Número de documento es requerido</span
          >
          <span class="md-error" v-if="!$v.ldata.documentNumber.numeric"
            >Documento no válido</span
          >
        </md-field>

        <!-- nombres -->
        <md-field :class="getValidationClass($v.ldata.firstName)">
          <label>Nombres</label>
          <md-input
            name="nombre"
            id="nombre"
            v-model="ldata.firstName"
            required
          ></md-input>
          <span class="md-error" v-if="!$v.ldata.firstName.required"
            >Nombres son requeridos</span
          >
          <span class="md-error" v-if="!$v.ldata.firstName.isAlpha"
            >Nombre no válido</span
          >
        </md-field>

        <!-- apellido paterno -->
        <md-field :class="getValidationClass($v.ldata.firstSurname)">
          <label>Apellido Paterno</label>
          <md-input
            name="apPaterno"
            id="apPaterno"
            v-model="ldata.firstSurname"
            required
          ></md-input>
          <span class="md-error" v-if="!$v.ldata.firstSurname.required"
            >Apellido paterno es requerido</span
          >
          <span class="md-error" v-if="!$v.ldata.firstSurname.isAlpha"
            >Campo requiere solo letras</span
          >
        </md-field>

        <!-- apellido materno -->
        <md-field :class="getValidationClass($v.ldata.secondSurname)">
          <label>Apellido Materno</label>
          <md-input
            name="apMaterno"
            id="apMaterno"
            v-model="ldata.secondSurname"
            required
          ></md-input>
          <span class="md-error" v-if="!$v.ldata.secondSurname.required"
            >Apellido materno es requerido</span
          >
          <span class="md-error" v-if="!$v.ldata.secondSurname.isAlpha"
            >Campo requiere solo letras</span
          >
        </md-field>

        <!-- apellido casada -->
        <md-field
          v-if="ldata.gender == 'female'"
          :class="getValidationClass($v.ldata.marriedSurname)"
        >
          <label>Apellido Casada</label>
          <md-input
            name="apCasada"
            id="apCasada"
            v-model="ldata.marriedSurname"
          ></md-input>
          <span class="md-error" v-if="!$v.ldata.marriedSurname.isAlpha"
            >Campo requiere solo letras</span
          >
        </md-field>

        <!-- fecha de nacimiento -->
        <md-field>
          <label>Fecha de Nacimiento</label>
          <v-date-picker
            v-model="dateBorn"
            class="datepick"
            popover-visibility="focus"
            :max-date="maxBornDate"
          >
            <md-input
              slot-scope="{ inputValue }"
              style="text-align:left !important"
              :value="inputValue"
              readonly
            ></md-input>
          </v-date-picker>
        </md-field>

        <!-- número telefónico -->
        <md-field :class="getValidationClass($v.ldata.phone)">
          <label>Número telefónico</label>
          <md-input
            name="phone"
            id="phone"
            v-model="ldata.phone"
            required
          ></md-input>
          <span class="md-error" v-if="!$v.ldata.phone.required"
            >Número telefónico es requerido</span
          >
          <span class="md-error" v-if="!$v.ldata.phone.isPhone"
            >Número telefónico no válido</span
          >
        </md-field>

        <!-- correo electronico -->
        <md-field :class="getValidationClass($v.ldata.email)">
          <label>Correo Electrónico</label>
          <md-input
            name="correoE"
            id="correoE"
            v-model="ldata.email"
            required
          ></md-input>
          <span class="md-error" v-if="!$v.ldata.email.required"
            >Correo electrónico es requerido</span
          >
          <span class="md-error" v-if="!$v.ldata.email.email"
            >Correo electrónico no válido</span
          >
        </md-field>

        <!-- género -->
        <div class="field-radio">
          <div class="field-radio__label">Sexo</div>
          <md-radio v-model="ldata.gender" value="male">Masculino</md-radio>
          <md-radio v-model="ldata.gender" value="female">Femenino</md-radio>
        </div>

        <div
          v-show="ldata.state != 'registered'"
          class="laborales__sgte"
          @click="nextForm('Principal')"
        >
          Siguiente
        </div>
      </div>

      <div class="laborales__direccion" v-show="currentView == 'Direccion'">
        <!-- pais -->
        <md-field>
          <label for="pais">País</label>
          <md-select
            v-model="ldata.country"
            name="pais"
            id="pais"
            placeholder="País"
            required
          >
            <md-option value="peru">Perú</md-option>
            <!-- <md-option value="brasil">Brasil</md-option> -->
          </md-select>
        </md-field>

        <!-- departamento -->
        <md-field>
          <label for="departamento">Departamento/Región</label>
          <md-select
            v-model="regionModal"
            name="departamento"
            id="departamento"
            placeholder="Departamento"
            required
            @md-selected="getProvinces"
          >
            <md-option
              :value="region.id"
              v-for="(region, $index) in regiones"
              :key="`region-${$index}`"
              >{{ region.name }}</md-option
            >
          </md-select>
        </md-field>

        <!-- provincia -->
        <md-field>
          <label for="provincia">Provincia</label>
          <md-select
            v-model="provinciaModal"
            name="provincia"
            id="provincia"
            placeholder="Provincia"
            required
            @md-selected="getDistritos"
          >
            <md-option
              :value="provincia.id"
              v-for="(provincia, $index) in provincias"
              :key="`provincia-${$index}`"
              >{{ provincia.name }}</md-option
            >
          </md-select>
        </md-field>

        <!-- distrito -->
        <md-field>
          <label for="distrito">Distrito</label>
          <md-select
            v-model="ldata.district"
            name="distrito"
            id="distrito"
            placeholder="Distrito"
            required
          >
            <md-option
              :value="distrito.id"
              v-for="(distrito, $index) in distritos"
              :key="`distrito-${$index}`"
              >{{ distrito.name }}</md-option
            >
          </md-select>
        </md-field>

        <!-- zona domicilio -->
        <md-field class="direccion">
          <label>Zona Domicilio</label>
          <md-input
            name="zonaDomicilio"
            id="zonaDomicilio"
            v-model="direccion"
            required
            style="text-transform:capitalize"
            @click="showDirectionModal = true"
          ></md-input>
        </md-field>

        <md-dialog
          :md-active.sync="showDirectionModal"
          :md-click-outside-to-close="false"
        >
          <md-dialog-title>Dirección</md-dialog-title>
          <div class="container-md">
            <md-autocomplete
              v-model="roadType"
              :md-options="roadTypes"
              md-input-id="roadtype"
              md-dense
              @md-selected="selectVia"
              required
              class="buscador"
            >
              <label>Tipo de Vía</label>
              <template slot="md-autocomplete-item" slot-scope="{ item }">
                {{ item.name }}
              </template>
            </md-autocomplete>

            <md-field>
              <label>Nombre de vía</label>
              <md-input v-model="ldata.address.roadName"></md-input>
            </md-field>

            <md-autocomplete
              v-model="zoneType"
              :md-options="zoneTypes"
              md-input-id="zonetype"
              md-dense
              @md-selected="selectZone"
              required
              class="buscador"
            >
              <label>Tipo de Zona</label>
              <template slot="md-autocomplete-item" slot-scope="{ item }">
                {{ item.name }}
              </template>
            </md-autocomplete>

            <md-field>
              <label>Nombre de Zona</label>
              <md-input v-model="ldata.address.zoneName"></md-input>
            </md-field>

            <div class="container-md__group">
              <md-field>
                <label>Nro vía</label>
                <md-input v-model="ldata.address.roadNumber"></md-input>
              </md-field>
              <md-field>
                <label>Bloque</label>
                <md-input v-model="ldata.address.block"></md-input>
              </md-field>
              <md-field>
                <label>Dpto</label>
                <md-input v-model="ldata.address.flat"></md-input>
              </md-field>
              <md-field>
                <label>Interior</label>
                <md-input v-model="ldata.address.interior"></md-input>
              </md-field>
              <md-field>
                <label>Manzana</label>
                <md-input v-model="ldata.address.square"></md-input>
              </md-field>
              <md-field>
                <label>Lote</label>
                <md-input v-model="ldata.address.lot"></md-input>
              </md-field>
              <md-field>
                <label>Kilómetro</label>
                <md-input v-model="ldata.address.km"></md-input>
              </md-field>
              <md-field>
                <label>Etapa</label>
                <md-input v-model="ldata.address.stage"></md-input>
              </md-field>
              <md-field>
                <label>Ubigeo</label>
                <md-input v-model="ldata.address.ubigeo"></md-input>
              </md-field>
            </div>
          </div>
          <md-dialog-actions>
            <md-button class="md-accent" @click="showDirectionModal = false"
              >Cerrar</md-button
            >
            <md-button class="md-primary" @click="loadDirection()"
              >Guardar</md-button
            >
          </md-dialog-actions>
        </md-dialog>

        <div
          v-show="ldata.state != 'registered'"
          class="laborales__sgte"
          @click="nextForm('Direccion')"
        >
          Siguiente
        </div>
      </div>

      <div class="laborales__laboral" v-show="currentView == 'Laboral'">
        <!-- fecha de ingreso -->
        <md-field>
          <label>Fecha de Ingreso</label>
          <v-date-picker
            v-model="dateInit"
            class="datepick"
            popover-visibility="focus"
          >
            <md-input
              slot-scope="{ inputProps, inputEvents, inputValue }"
              style="text-align:left !important"
              v-bind="inputProps"
              v-on="inputEvents"
              readonly
              :value="inputValue"
            ></md-input>
          </v-date-picker>
        </md-field>

        <!-- regimen laboral -->
        <md-field>
          <label for="regLab">Régimen Laboral</label>
          <md-select
            v-model="ldata.laborRegime"
            name="regimen"
            id="regimen"
            required
          >
            <!-- <md-option value="pequena">Pequeña Empresa</md-option> -->
            <md-option value="01">General - D LEG No 728</md-option>
            <!-- <md-option value="21">Construcción Civil</md-option> -->
            <md-option value="16">Microempresa - D LEG No 1086</md-option>
            <md-option value="17">Pequeña Empresa - D LEG No 1086</md-option>
          </md-select>
        </md-field>

        <!-- tipo de contrato -->
        <md-field>
          <label for="tipoContrato">Tipo de Contrato</label>
          <md-select
            v-model="ldata.contractType"
            name="contrato"
            id="contrato"
            required
          >
            <md-option value="01">Plazo Indeterminado</md-option>
            <md-option value="02">Tiempo Parcial</md-option>
            <md-option value="03"
              >Por Inicio o Incremento de Actividad</md-option
            >
            <md-option value="04">Por Necesidad de Mercado</md-option>
            <md-option value="07">De Suplencia</md-option>
            <md-option value="13">Trabajador Extranjero</md-option>
            <md-option value="14">Administrativo de Servicios</md-option>
            <md-option value="06">Contrato Ocasional</md-option>
            <!-- <md-option value="-1">Practicante</md-option> -->
          </md-select>
        </md-field>

        <!-- tipo de trabajador -->
        <md-field>
          <label for="tipoTrabaj">Tipo de Trabajador</label>
          <md-select
            v-model="ldata.workerType"
            name="regimen"
            id="regimen"
            required
          >
            <md-option value="19">EJECUTIVO</md-option>
            <md-option value="20">OBRERO</md-option>
            <md-option value="21">EMPLEADO</md-option>
            <md-option value="27">CONSTRUCCIÓN CIVIL</md-option>
          </md-select>
        </md-field>

        <!-- jornada de trabajo -->
        <md-field>
          <label for="jornLab">Jornada Laboral</label>
          <md-select
            v-model="ldata.workdayType"
            name="jornada"
            id="jornada"
            required
          >
            <md-option value="1">Jornada de trabajo máxima</md-option>
            <md-option value="2">Jornada atípica o acumulativa</md-option>
            <md-option value="3">Trabajo en horario nocturno</md-option>
          </md-select>
        </md-field>

        <!-- ocupacion -->
        <md-autocomplete
          v-model="ldata.occupationLabel"
          :md-options="occupationsComp"
          md-input-id="buscador"
          md-dense
          :md-open-on-focus="false"
          @input.native="searchOccupation($event.target.value)"
          @md-selected="selectOccupation"
          required
          class="buscador-empleo"
        >
          <label>Ocupación</label>
          <template slot="md-autocomplete-item" slot-scope="{ item }">
            {{ item.name }}
          </template>
        </md-autocomplete>

        <md-field>
          <label for="charge">Cargo</label>
          <md-input
            name="charge"
            id="charge"
            v-model="ldata.professionalPosition"
          ></md-input>
        </md-field>

        <!-- tipo de pago -->
        <md-field>
          <label for="payment">Tipo de Pago</label>
          <md-select
            v-model="ldata.paymentType"
            name="payment"
            id="payment"
            required
          >
            <md-option value="1">Efectivo</md-option>
            <md-option value="2">Depósito</md-option>
          </md-select>
        </md-field>

        <!-- periodicidad -->
        <md-field>
          <label for="paymentPeriod">Periodicidad</label>
          <md-select
            v-model="ldata.periodicityPayment"
            name="paymentPeriod"
            id="paymentPeriod"
            required
          >
            <md-option value="1">Mensual</md-option>
            <md-option value="2">Quincenal</md-option>
            <md-option value="3">Semanal</md-option>
            <md-option value="4">Diario</md-option>
            <!-- <md-option value="5">Otros</md-option> -->
          </md-select>
        </md-field>

        <!-- sueldo bruto -->
        <md-field :class="getValidationClass($v.ldata.grossSalary)">
          <label>Sueldo Bruto</label>
          <span class="md-prefix">S/.</span>
          <md-input
            name="sueldoBruto"
            id="sueldoBruto"
            v-model.number="ldata.grossSalary"
            required
          ></md-input>
          <span class="md-error" v-if="!$v.ldata.grossSalary.required"
            >Sueldo bruto es requerido</span
          >
          <span class="md-error" v-if="!$v.ldata.grossSalary.decimal"
            >Sueldo no válido</span
          >
        </md-field>

        <!-- es ria -->
        <div class="field-radio">
          <div class="field-radio__label">Es RIA</div>
          <md-checkbox v-model="ldata.isRIA">Ría</md-checkbox>
          <!-- <md-radio v-model="ldata.unionized" :value="true">Sí</md-radio>
          <md-radio v-model="ldata.unionized" :value="false">No</md-radio> -->
        </div>

        <!-- banco a depositar -->
        <md-field v-if="ldata.paymentType == '2'">
          <label>Banco a Depositar</label>
          <md-input
            name="nombreBanco"
            id="nombreBanco"
            v-model="ldata.bankName"
            required
          ></md-input>
          <!-- <span class="md-error" v-if="!$v.ldata.bankName.required">Nombre del Banco es requeridos</span>
          <span class="md-error" v-if="!$v.ldata.bankName.isAlpha">Nombre no válido</span> -->
        </md-field>
        <!-- numero de cuenta -->
        <md-field
          :class="getValidationClass($v.ldata.bankAccount)"
          v-if="ldata.paymentType == '2'"
        >
          <label>Número Cuenta</label>
          <md-input
            name="nroCuenta"
            id="nroCuenta"
            v-model="ldata.bankAccount"
            required
          ></md-input>
          <span class="md-error" v-if="!$v.ldata.bankAccount.required"
            >Número de cuenta es requerido</span
          >
          <span class="md-error" v-if="!$v.ldata.bankAccount.numeric"
            >Número no válido</span
          >
        </md-field>

        <md-field
        >
          <label>Número Cuenta para CTS</label>
          <md-input
            name="nroCuentaCts"
            id="nroCuentaCts"
            v-model="ldata.bankAccountCTS"
          ></md-input>
        </md-field>

        <!-- <md-field v-if="ldata.paymentType=='2'">
          <label>Banco a Depositar</label>
          <md-input name="nombreBanco" id="nombreBanco" v-model="ldata.bankName" required></md-input>
        </md-field> -->

        <!-- horas contractuales -->
        <md-field :class="getValidationClass($v.ldata.contractualHours)">
          <label>Horas Contrato</label>
          <span class="md-prefix">⌛</span>
          <md-input v-model.number="ldata.contractualHours" required></md-input>
          <span class="md-error" v-if="!$v.ldata.contractualHours.required"
            >Horas contrato es requerido</span
          >
          <span class="md-error" v-if="!$v.ldata.contractualHours.hourLaboral"
            >Horas no válidas</span
          >
        </md-field>

        <!-- sindicalizado -->
        <div class="field-radio">
          <div class="field-radio__label">Sindicalizado</div>
          <md-radio v-model="ldata.unionized" :value="true">Sí</md-radio>
          <md-radio v-model="ldata.unionized" :value="false">No</md-radio>
        </div>

        <!-- discapacitado -->
        <div class="field-radio">
          <div class="field-radio__label">Discapacitado</div>
          <md-radio v-model="ldata.personWithDisability" :value="true"
            >Sí</md-radio
          >
          <md-radio v-model="ldata.personWithDisability" :value="false"
            >No</md-radio
          >
        </div>
        <div
          class="field-radio"
          v-if="
            ['micro', 'little'].includes(
              $store.state.enterprise.dataBusiness.type
            )
          "
        >
          <div class="field-radio__label">Asignación familiar</div>
          <md-checkbox v-model="ldata.hasFamilyAssignment"
            >Activar Asignación familiar</md-checkbox
          >
        </div>
        <div
          class="field-radio"
          v-if="$store.state.enterprise.dataBusiness.type === 'micro'"
        >
          <div class="field-radio__label">Gratificación</div>
          <md-checkbox v-model="ldata.hasGratification"
            >Asignar Gratificación</md-checkbox
          >
        </div>
        <md-field v-if="ldata.hasGratification">
          <label for="paymentPeriod">Monto de Gratificación</label>
          <md-select
            v-model="ldata.gratificationType"
            name="gratificationType"
            id="gratificationType"
            required
          >
            <md-option :value="0.5">Media</md-option>
            <md-option :value="1">Completa</md-option>
            <!-- <md-option value="5">Otros</md-option> -->
          </md-select>
        </md-field>
        <div
          class="field-radio"
          v-if="$store.state.enterprise.dataBusiness.type === 'micro'"
        >
          <div class="field-radio__label">CTS</div>
          <md-checkbox v-model="ldata.hasCts">Asignar CTS</md-checkbox>
        </div>
        <md-field v-if="ldata.hasCts">
          <label for="paymentPeriod">Monto de CTS</label>
          <md-select
            v-model="ldata.ctsType"
            name="gratificationType"
            id="gratificationType"
            required
          >
            <md-option :value="0.5">Media</md-option>
            <md-option :value="1">Completa</md-option>
            <!-- <md-option value="5">Otros</md-option> -->
          </md-select>
        </md-field>
        <div
          v-show="ldata.state != 'registered'"
          class="laborales__sgte"
          @click="nextForm('Laboral')"
        >
          Siguiente
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const Ubigeoperu = require("peru-ubigeo");
var ubigeo = new Ubigeoperu();
import { mapActions } from "vuex";

import { validationMixin } from "vuelidate";
import {
  required,
  alpha,
  email,
  alphaNum,
  numeric,
  helpers,
  decimal,
} from "vuelidate/lib/validators";
import { constants } from "crypto";

import { Region, Province, District } from "ubigeos";
import ubigeos from "ubigeos";
import EventBus from "@/eventBus";
const isAlpha = helpers.regex("alpha", /^[a-zA-ZÀ-ÿñÑ ]*$/);
const isPhone = helpers.regex("numeric", /^9[0-9]{8}$/);
const hourLaboral = helpers.regex("numeric", /^(?:[1-9])$/);

export default {
  mixins: [validationMixin],
  props: {
    value: Object,
    isHistoric: Boolean,
    historicId: String,
  },
  created() {
    // const region = new Region('25');
    // const names = ubigeos('250107');
    this.searchOccupation();
    this.regiones = ubigeo.getRegions();
    // console.log(new Region())

    // console.log(this.value)
    if (this.value.id) {
      this.ldata = this.value;
      // this.ldata = Object.assign(this.ldata,this.value)
      // console.log('entreo')
      // if(this.ldata.bornDate == undefined){
      //   this.ldata.bornDate = this.maxBornDate.toISOString()
      // }
    } else {
      //cuando creas nuevo usuario
      // console.log('data vacia')
      //solucion para tregsitro vacio(error naranja)
      //Ni tan solucion :'v manda payload en null
    }
  },
  mounted() {},
  data() {
    return {
      ldata: {
        occupation: {
          name: "",
          code: "",
        },
        address: {
          roadType: "",
          roadName: "",
          roadNumber: "",
          flat: "",
          interior: "",
          square: "",
          lot: "",
          km: "",
          block: "",
          stage: "",
          zoneType: "",
          zoneName: "",
          reference: "",
          ubigeo: "",
        },
      },
      occupations: [],
      roadType: null,
      roadTypes: [
        { code: "01", label: "Av", name: "Avenida" },
        { code: "02", label: "Jr", name: "Jirón" },
        { code: "03", label: "Ca", name: "Calle" },
        { code: "04", label: "Pje", name: "Pasaje" },
        { code: "05", label: "Al", name: "Alameda" },
        { code: "06", label: "Ml", name: "Malecón" },
        { code: "07", label: "Ov", name: "Óvalo" },
        { code: "08", label: "Pq", name: "Parque" },
        { code: "09", label: "Pl", name: "Plaza" },
        { code: "10", label: "Cr", name: "Carretera" },
        { code: "14", label: "Cm", name: "Camino Rural" },
        { code: "15", label: "Ba", name: "Bajada" },
        { code: "16", label: "Ga", name: "Galería" },
        { code: "17", label: "Pr", name: "Prolongación" },
        { code: "18", label: "Pas", name: "Paseo" },
        { code: "19", label: "Pz", name: "Plazuela" },
        { code: "99", label: "Vía", name: "Otro" },
      ],
      zoneType: null,
      zoneTypes: [
        { code: "01", label: "URB.", name: "Urbanización" },
        { code: "02", label: "P.J.", name: "Pueblo Joven" },
        { code: "03", label: "U.V.", name: "Unidad Vecinal" },
        { code: "04", label: "C.H.", name: "Conjunto Habitacional" },
        { code: "05", label: "A.H.", name: "Asentamiento Humano" },
        { code: "06", label: "COO.", name: "Cooperativa" },
        { code: "07", label: "RES.", name: "Residencial" },
        { code: "08", label: "Z.I.", name: "Zona Industrial" },
        { code: "09", label: "GRU.", name: "Grupo" },
        { code: "10", label: "CAS.", name: "Caserío" },
        { code: "11", label: "FND.", name: "Fundo" },
        { code: "99", label: "Zona", name: "Otros" },
      ],
      direccion: null,

      //principal
      nombres: null,
      apPaterno: null,
      apMaterno: null,
      apCasada: null,
      correoE: null,
      documentType: "dni",
      nroDocumento: null,
      // dateBorn: null,
      sexo: "mujer",
      // tipoSangre: "o+",

      //direccion
      pais: "peru",
      departamento: "lima",
      provincia: "lima",
      distrito: "cercado",
      zonaDomicilio: null,
      dirReniec: true,
      dirDomicilio: null,
      ubigeo: null,
      regiones: [],
      regionModal: null,
      provincias: [],
      provinciaModal: null,
      distritos: [],
      distritoModal: null,
      //laboral
      // dateInit: null,
      inputValueInit: null,
      regLab: "pequena",
      tipoContrato: "indet",
      tipoTrabaj: "empleado",
      jornLab: "trabajoMax",
      ocupacion: "gerGral",
      sueldoBruto: null,
      nroCuenta: null,
      bankName: null,
      sindicalizado: true,
      discapacitado: false,
      hasGratification: false,
      gratificationType: null,
      hasCts: false,
      ctsType: null,
      hasFamilyAssignment: false,
      currentView: "Principal",
      professionalPosition: null,
      //show Direction Modal
      showDirectionModal: false,
      //direction
      typeVia: null,
      viaName: null,
      nVia: null,
      block: null,
      int: null,
      dpto: null,
      mza: null,
      lote: null,
      km: null,
      //laboral
      typePayment: null,
      paymentPeriod: null,
    };
  },

  validations: {
    nombres: { required, isAlpha },
    apPaterno: { required, isAlpha },
    apMaterno: { required, isAlpha },
    apCasada: { isAlpha },
    correoE: { email, required },
    nroDocumento: { numeric, required },

    zonaDomicilio: { required },
    dirDomicilio: { required },

    sueldoBruto: { numeric, required },
    nroCuenta: { numeric, required },
    ldata: {
      documentNumber: { numeric, required },
      firstName: { required, isAlpha },
      firstSurname: { required, isAlpha },
      secondSurname: { required, isAlpha },
      marriedSurname: { isAlpha },
      email: { email, required },
      // address: {required},
      grossSalary: { decimal, required },
      bankAccount: { numeric, required },
      backName: { required, isAlpha },
      phone: { required, isPhone },
      contractualHours: { required, hourLaboral },
    },
  },

  //cuando la "data" de tregister es actualizada
  //inmediatamente cambia this.ldata
  watch: {
    value(newValue, oldValue) {
      // this.ldata = Object.assign(this.ldata,newValue)
      console.log(newValue);

      this.ldata = newValue;
      // this.ldata.bornDate = this.maxBornDate.toISOString()
      // if(this.ldata.bornDate == undefined)
      // Object.assign(this.ldata,{bornDate: this.maxBornDate.toISOString()})
      if (this.ldata.department) {
        this.regiones = ubigeo.getRegions();
        this.regionModal = this.ldata.department;
        // console.log(this.regionModal);
      }
      if (this.ldata.province) {
        this.provincias = this.regiones
          .find((r) => r.id == this.regionModal)
          .provinces();
        this.provinciaModal = this.ldata.province;
      }

      if (this.ldata.district) {
        this.distritos = this.provincias.find(
          (p) => p.id == this.provinciaModal
        )
          ? this.provincias.find((p) => p.id == this.provinciaModal).districts()
          : null;
      }
      if (this.ldata.address.roadType) {
        // console.log('holii')

        this.roadType = this.roadTypes.filter(
          (item) => item.code == this.ldata.address.roadType
        )[0].name;
      }

      if (this.ldata.address.zoneType)
        this.zoneType = this.zoneTypes.filter(
          (item) => item.code == this.ldata.address.zoneType
        )[0].name;

      if (this.ldata.address.roadType && this.ldata.address.zoneType)
        this.loadDirection();

      // this.updateTRegister(this.ldata)
    },
    // ldata:{
    //   deep: true,
    //   handler: function(n, o){
    //     console.log(n.department, o.department);
    //     this.provincias =
    //   }
    // }
  },

  computed: {
    // ldata(){
    //   return this.data
    // }
    occupationsComp() {
      return this.occupations;
    },
    dateBorn: {
      get() {
        // if(!this.ldata.bornDate)
        //   return this.maxBornDate
        return new Date(this.ldata.bornDate);
      },
      set(value) {
        this.setBornDate({ date: value });
      },
    },
    dateInit: {
      get() {
        if (!this.ldata.admittedAt) return new Date();
        console.log(this.ldata.admittedAt);
        return new Date(this.ldata.admittedAt);
      },
      set(value) {
        console.log(value);
        this.setInitDate(value);
      },
    },

    maxBornDate() {
      return new Date(
        new Date().getFullYear() - 18,
        new Date().getMonth(),
        new Date().getDate()
      );
    },
    riaLimit() {
      return 2 * this.$store.state.enterprise.dataBusiness.uit;
    },
  },

  methods: {
    ...mapActions({
      updateTRegister: "updateTRegister",
      getOccupations: "getOccupations",
      getTRegisters: "getTRegisters",
    }),

    getValidationClass(validation) {
      if (validation.$model === null) {
        return {
          "md-invalid": validation.$invalid && validation.$dirty,
        };
      } else {
        validation.$touch();
        return {
          "md-invalid": validation.$invalid && validation.$dirty,
        };
      }
    },
    dateParsed(fecha) {
      if (fecha == "" || fecha === null) return "";
      else
        return (
          fecha.getDate() +
          "/" +
          (fecha.getMonth() + 1) +
          "/" +
          fecha.getFullYear()
        );
    },
    nextForm(val) {
      let stateLocal = "";
      EventBus.$on((val) => {
        stateLocal = val;
      });
      // this.$emit('updateData',this.ldata)
      if (!this.isHistoric) {
        this.updateTRegister(this.ldata).then((r) => {
          if (r.status == 200) {
            this.getTRegisters({
              id: this.$localStorage.get("businessID"),
              state: stateLocal,
              page: 1,
            }).then((res) => {
              if (res.status == 200) {
                this.$toasted.success("T-registro actualizado", {
                  theme: "bubble",
                  position: "top-right",
                  duration: 1000,
                  className: "short-message",
                });
              }
            });
          }
        });
      } else {
        this.$store
          .dispatch("updateTregistersHistoric", {
            id: this.$store.state.business.currentTRegister,
            fk: this.historicId,
            body: this.ldata,
          })
          .then((res) => {
            if (res.status == 200) {
                this.$toasted.success("T-registro Historico actualizado", {
                  theme: "bubble",
                  position: "top-right",
                  duration: 1000,
                  className: "short-message",
                });
              }
          });
      }

      switch (val) {
        case "Principal":
          this.currentView = "Direccion";
          break;
        case "Direccion":
          this.currentView = "Laboral";
          break;
        case "Laboral":
          this.$emit("nextForm");
          break;
      }
      // this.getTRegisters(this.$localStorage.get('businessID'))
    },

    setBornDate(value) {
      // console.log(value)
      this.ldata.bornDate = value.date.toISOString();
    },
    setInitDate(value) {
      console.log(value);
      // this.ldata.admittedAt = new Date(value);
      this.$set(this.ldata, "admittedAt", new Date(value).toISOString());
      console.log(this.ldata.admittedAt);
    },
    saveDirection() {
      this.ldata.address =
        [
          this.typeVia,
          this.viaName,
          "Nro " + this.nVia,
          "Bloque " + this.block,
          "Dpto " + this.dpto,
          "Int " + this.int,
          "Mza " + this.mza,
          "Lote " + this.lote,
          "Km " + this.km,
        ]
          .filter((r) => !r.includes("null"))
          .join(" ") +
        " " +
        this.ldata.department +
        " - " +
        this.ldata.province +
        " - " +
        this.ldata.district;
      this.showDirectionModal = false;
    },

    loadDirection() {
      this.direccion = [
        this.roadTypes.filter((item) => item.name == this.roadType)[0].label,
        this.ldata.address.roadName,
        "Nro " + this.ldata.address.roadNumber,
        "Bloque " + this.ldata.address.block,
        "Dpto " + this.ldata.address.flat,
        "Int " + this.ldata.address.interior,
        "Mza " + this.ldata.address.square,
        "Lote " + this.ldata.address.lot,
        "Km " + this.ldata.address.km,
        this.zoneTypes.filter((item) => item.name == this.zoneType)[0].label,
        this.ldata.address.zoneName,
        "Etapa " + this.ldata.address.stage,
      ]
        .filter((r) => r[r.length - 1] != " ")
        .join(" ");

      this.showDirectionModal = false;
    },

    selectOccupation(item) {
      // console.log("el item: ",item)
      (this.ldata.occupation.name = this.ldata.occupationLabel = item.name),
        (this.ldata.occupation.code = item.code);
    },

    selectVia(value) {
      (this.roadType = value.name), (this.ldata.address.roadType = value.code);
    },

    selectZone(value) {
      (this.zoneType = value.name), (this.ldata.address.zoneType = value.code);
    },

    searchOccupation($e = "") {
      // console.log($e);

      this.getOccupations($e).then((r) => {
        if (r.status == 200) {
          // console.log('resu:', r)
          this.occupations = r.data.results;
        }
      });
    },
    getProvinces($event) {
      // console.log(this.regionModal);
      this.ldata.department = this.regionModal;
      this.provincias = this.regiones
        .find((r) => r.id == this.regionModal)
        .provinces();
      // console.log(this.provincias);
    },
    getDistritos($event) {
      // console.log(this.provinciaModal);
      this.ldata.province = this.provinciaModal;
      this.distritos = this.provincias
        .find((p) => p.id == this.provinciaModal)
        .districts();
      // console.log(this.distritos);
    },
  },
};
</script>
<style lang="scss">
.datepick {
  border-bottom: 1px solid #d7dae2;
  &__input {
    font-size: 16px;
    color: rgba(#000, 0.87);
    &::placeholder {
      color: rgba(#000000, 0.6);
    }
  }
  input[type="text"] {
    font-size: 16px;
    color: rgba(#000, 0.87);
    &::placeholder {
      color: rgba(#000000, 0.6);
    }
  }
}

.md-menu-content {
  &.md-select-menu {
    z-index: 1000 !important;
  }
}

.md-menu-content {
  z-index: 900 !important;
  min-width: 18rem !important;
}

// .md-menu-content.buscador-empleo{
//   width: 18rem !important;
//   max-width: none !important;
// }
</style>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-VENDORS
.tab-selected {
  background-color: #fff !important;
  font-weight: 700 !important;
  border: 1px solid rgba($b-orange, 0.75) !important;
  border-bottom: 1px solid white !important;
}

.field-radio {
  // margin: 0 2rem 1rem 24px;
  width: 18rem;
  padding-top: 16px;
  position: relative;
  &__label {
    position: absolute;
    top: 0;
    font-size: 12px;
    color: rgba($b-blue, 0.6);
  }
}

//datepicker
.datepick {
  border-bottom: 1px solid #d7dae2;
  &__input {
    font-size: 16px;
    color: rgba(#000, 0.87);
    &::placeholder {
      color: rgba($b-blue, 0.6);
    }
  }
  input[type="text"] {
    font-size: 16px;
    color: rgba(#000, 0.87);
    &::placeholder {
      color: rgba($b-blue, 0.6);
    }
  }
}
//vue-material
.md-field {
  width: 18rem;
  margin: 4px 0 18px;

  &.md-theme-default {
    label {
      color: rgba($b-blue, 0.6);
      &::after {
        color: $b-orange;
      }
    }
    &::after {
      background-color: #d7dae2;
    }
    &::before {
      background-color: $b-blue;
    }
    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }
      &::after {
        background-color: $b-orange;
      }
      .md-error {
        color: $b-orange;
      }
    }
  }
}

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//8-TRUMPS
.camp-large {
  width: 18rem !important;
  @include mq($sm) {
    width: 30rem !important;
  }
}

.md-dialog {
  z-index: 900;
  padding: 1rem 3rem;
  max-width: 30rem;
  @include mq($sm) {
    height: 45rem;
    max-height: 46rem;
  }
}

.container-md {
  display: flex;
  flex-wrap: wrap;
  @include mq($md) {
  }
  &__group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    @include mq($md) {
      // width: 100%;
    }
    .md-field {
      width: 6rem;
      margin-right: 1rem;
      @include mq($md) {
        width: 6rem;
      }
    }
  }
}

.direccion {
  @include mq($md) {
    width: 30rem;
  }
}

.laborales {
  margin: 0 auto;
  padding-bottom: 2rem;
  @include mq($md) {
    width: 90%;
  }

  &__tabs {
    display: flex;
    flex-wrap: wrap;
    padding: 0 1rem;
    justify-content: center;
    @include mq($md) {
      justify-content: flex-start;
    }
  }
  &__tab {
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    background-color: #e6e6e6;
    color: $b-blue-dark;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-right: 3px;
    margin-top: 0.5rem;
    @include mq($md) {
      cursor: pointer;
    }
  }

  &__views {
    // position: relative;
    padding: 1rem 1rem 3rem 1rem;
    background-color: #fff;
    // height: 100%;
    @include mq($sm) {
      padding: 1rem 3rem 3rem 3rem;
    }
    @include mq($md) {
      border-radius: 6px;
    }
  }

  &__principal,
  &__direccion,
  &__laboral {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;

    @include mq($md) {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }

  &__sgte {
    position: absolute;
    bottom: -3rem;
    right: 3rem;
    width: 8rem;
    height: 2rem;
    text-align: center;
    line-height: 2rem;
    background-color: $b-orange;
    color: #fff;
    clip-path: polygon(91% 0%, 100% 50%, 91% 100%, 0% 100%, 9% 50%, 0% 0%);
    font-weight: 600;
    user-select: none;
    @include mq($lg) {
      cursor: pointer;
    }
  }
}
</style>
